import { Injectable } from '@angular/core';
import { LayerGroup, Map, Polyline, Icon, Marker, LatLng, FeatureGroup, DivIcon, Popup } from 'leaflet';

import { BusinessEvent } from '../../../../models/domain/BusinessEvent';
import { RouteEvent } from '../../../../models/domain/RouteEvent';
import { MapService } from '../../map/map.service';
import { Consts } from '../../../../consts/consts';
import { TranslateService } from '@ngx-translate/core';


/**
 * Provides route drawing utilities
 */
@Injectable()
export class EventDrawerService {


    /**
     * Costructor of service
     * @param $mapService map service
     */
    public constructor(
        private $map: MapService,
        private translate: TranslateService,
    ) { }


    /**
     * Draws given event on a map
     * @param event business event
     */
    public drawEvent(event: BusinessEvent): void {

        // Create marker and it to feature group
        const lat = parseFloat(event.EL.Lt);
        const lng = parseFloat(event.EL.Ln);

        const pinIcon = new DivIcon({
            'html': `
            <div class="event-pin-map-position">
                <img src="/assets/img/event-map-position.svg" />
            </div>`,
        });

        const marker = new Marker([lat, lng], {
            icon: pinIcon
            // icon: new Icon({
            //     iconUrl: '/assets/img/pin.png',
            //     iconSize: [32, 32], // size of the icon
            //     iconAnchor: [16, 32], // point of the icon which will correspond to marker's location
            // })
        });


        this.$map.groups.events.addLayer(marker);

        // Create popup
        const popup = new Popup({ 'className': 'event-popup', 'closeButton': false, 'keepInView': false, autoPan: false });
        marker.bindPopup(popup);
        popup.setLatLng([lat, lng]);
        popup.setContent(this.getPupupHTML(event));
    }


    /**
    * Removes all drawn events
    */
    public removeAll(): void {

        this.$map.groups.events.clearLayers();
    }


    /**
     * Fit to bounds to visible events
     */
    public fitBoundsToVisibleEvents(): void {

        const bounds = this.$map.groups.events.getBounds();
        if (bounds && bounds.isValid()) {
            this.$map.map!.fitBounds(bounds, Consts.MapPadding);
        }
    }


    /**
     * Returns popup html for given event
     * @param event business event
     */
    private getPupupHTML(event: BusinessEvent): string {

        const location = event.EL;

        const lat = location.Lt.toString().replace(',', '.');
        const lng = location.Ln.toString().replace(',', '.');

        // const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
        const googleMapsUrl = `https://www.google.com/maps?t=k&q=${lat}+${lng}`;
        const googleMapsIcon = `/assets/img/primary.png`;

        const html = `
            <div class="event-popup__content">
            <a class="event-popup__icon" href="${googleMapsUrl}" target="_blank">
            <img src="${googleMapsIcon}"/>
        </a>
        <div class="event-popup__label">${ this.translate.instant('showOnExternalMap') }</div>
            </div>
        `;

        return html;
    }

}
